//import React, { Component } from 'react';
import React, { HTMLAttributes } from "react";
import * as PropTypes from "prop-types";
import Cache from "core/cache/index";
import renderToCanvas from "component/molecules/viewport/core/render/renderToCanvas.js";
import "./Thumbnail.styl";

/**
 * @description LayoutChooser UI Component Properties
 *
 * @interface ILayoutChooserProps
 * @extends {HTMLAttributes<HTMLDivElement>}
 */
interface IThumbnailProps extends HTMLAttributes<HTMLDivElement> {
  /**
   * @description 섬네일로 출력할 영상 데이터
   */
  seriesID: any;
  thumbnailFrame: number;
}

/**
 * @description 사각영역에 이미지를 출력하는 UI Component
 *
 * @class Thumbnail
 * @extends {React.PureComponent<IThumbnailProps, any>}
 */
class Thumbnail extends React.PureComponent<IThumbnailProps, any> {
  static propTypes: PropTypes.InferProps<IThumbnailProps>;

  /// canvas element
  private canvasElement: any = null;

  /**
   * @description 사각영역의 크기 변경 이벤트를 처리하는 핸들러 등록 및
   * 영상 출력
   * @method componentDidMount
   * @memberof Thumbnail
   */
  componentDidMount() {
    this.renderDicomDataAsync();
  }

  /**
   * @description 컴포넌트 Property 업데이트시, thumbnail 이미지를 새로 그린다.
   * @method componentDidUpdate
   * @memberof Thumbnail
   */
  componentDidUpdate() {
    this.renderDicomDataAsync();
  }

  /**
   * @method renderDicomDataAsync
   * @description DICOM 데이터를 캔버스에 출력
   * @memberof Thumbnail
   */
  renderDicomDataAsync() {
    const { seriesID, thumbnailFrame } = this.props;
    let metadataCache = new Cache.Metadata();
    const frame = metadataCache.getFrame(seriesID, thumbnailFrame);

    return new Promise((resolve, reject) => {
      try {
        frame.width = frame.columns;
        frame.height = frame.rows;
        renderToCanvas(this.canvasElement, frame);
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  }

  /**
   * @method render
   * @description 컴포넌트의 UI를 렌더링
   * @memberof Thumbnail
   */
  render() {
    return (
      <div className="imageThumbnail">
        <div className="imageThumbnailCanvas">
          <canvas
            className="static-image"
            ref={canvasElement => {
              this.canvasElement = canvasElement;
            }}
          />
        </div>
      </div>
    );
  }
}

export default Thumbnail;
